"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Guid = void 0;
const uuid = __importStar(require("uuid"));
class Guid {
    constructor(value) {
        this.value = value;
    }
    static next() {
        return new Guid(uuid.v4());
    }
    static default() {
        return new Guid('00000000-0000-4000-8000-000000000000');
    }
    static isValid(obj) {
        if (!obj) {
            return false;
        }
        const stringObj = obj.toString();
        return /^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i.test(stringObj);
    }
    static fromString(str) {
        if (!Guid.isValid(str)) {
            return null;
        }
        return new Guid(str);
    }
    isDefault() {
        return this.value === Guid.default().value;
    }
    is(another) {
        if (!another) {
            return false;
        }
        return this.value === another.value;
    }
    toString() {
        return this.value;
    }
    toAlphaNumericString() {
        return this.value.replace(/-/g, '');
    }
}
exports.Guid = Guid;
//# sourceMappingURL=guid.js.map